import { Box, css, Grid } from '@mui/material'

import { useMQ } from '../hooks/useMQ'
import { CONFIG } from '../utils/config'
import { HumaWhiteIcon } from './icons'
import BackgroundImg from './images/footer-background.png'
import { SocialMedia } from './SocialMedia'

export function Footer() {
  const year = new Date().getFullYear()
  const { isXsSize, isSmSize, isLgSize } = useMQ()

  const getLogoWrapperStyle = () => {
    if (isSmSize) {
      return css`
        width: 100%;
        align-items: center;
        margin-bottom: 50px;
        align-items: ${isXsSize ? 'center' : 'flex-start'};

        & > svg {
          margin-bottom: 10px;
        }
      `
    }
  }

  const getLogoStyle = () => {
    if (isSmSize) {
      return {
        width: '124px',
        height: '26px',
      }
    }
  }

  const getSocialMediaStyle = () => {
    if (isXsSize) {
      return css`
        margin-top: 60px;
        margin-bottom: 70px;
      `
    }
    if (isSmSize) {
      return css`
        margin-top: 20px;
        margin-bottom: 70px;
      `
    }
    if (isLgSize) {
      return css`
        & > div {
          flex-direction: row;
          justify-content: end;
        }
      `
    }
  }

  const styles = {
    wrapper: css`
      width: 100%;
      height: ${isXsSize ? '600px' : '440px'};
      z-index: 2;
      position: relative;
      display: flex;
      justify-content: space-between;
      background: #000000;
      padding: ${isXsSize ? '100px 32px' : '120px 85px'};
      box-sizing: border-box;
    `,
    backgroundImg: css`
      z-index: 0;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    `,
    left: css`
      width: 750px;
      display: flex;
      justify-content: space-between;
    `,
    logoWrapper: css`
      display: flex;
      flex-direction: column;
      font-size: 20px;
      line-height: 150%;
      color: #999999;
      margin-bottom: 24px;
      & > svg {
        margin-bottom: 21px;
      }
      ${getLogoWrapperStyle()}
    `,
    logo: {
      width: '174px',
      height: '40px',
      ...getLogoStyle(),
    },
    linkWrapper: css`
      font-family: 'Red-Hat-Display';
      display: flex;
      flex-direction: column;
      font-size: 16px;
      line-height: 150%;
      color: #999999;
      margin-bottom: ${isXsSize ? '16px' : '0'};

      & > div:first-of-type {
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 8px;
      }

      & > a {
        color: #999999;
        text-decoration: none;
        line-height: 150%;
        white-space: nowrap;
        &:hover {
          text-decoration: underline;
        }
      }
    `,
    right: css``,
    allRights: css`
      width: 100%;
      display: flex;
      justify-content: center;
      position: absolute;
      transform: translate(-50%);
      left: 50%;
      bottom: 20px;
      font-size: 14px;
      line-height: 150%;
      color: #a8a1b2;
    `,
    socialMedia: css`
      ${getSocialMediaStyle()}
    `,
    subtitle: css`
      font-size: 14px;
      line-height: 120%;
      text-align: ${isXsSize ? 'center' : 'left'};
    `,
    footerContainer: css`
      z-index: 1;
    `,
  }

  return (
    <Box css={styles.wrapper}>
      <img
        css={styles.backgroundImg}
        src={BackgroundImg}
        alt='footer-background'
      ></img>
      <Grid css={styles.footerContainer} width='100%' container spacing={0}>
        <Grid item xs={12} sm={4} md={4} lg={3}>
          <Box css={styles.logoWrapper}>
            <HumaWhiteIcon {...styles.logo} />
            <Box css={styles.subtitle}>The First PayFi Network.</Box>
          </Box>
          <SocialMedia />
        </Grid>
        <Box display='flex' flexGrow={1} />
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          lg={2}
          display='flex'
          alignItems={isXsSize ? 'flex-start' : 'center'}
          flexDirection='column'
          justifyContent='flex-start'
        >
          <Box css={styles.linkWrapper}>
            <Box>PRODUCT</Box>
            <a
              href={CONFIG.permissionlessLink}
              target='_blank'
              rel='noreferrer'
            >
              Huma 2.0
            </a>
            <a href={CONFIG.institutionalLink} target='_blank' rel='noreferrer'>
              Huma Institutional
            </a>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          lg={2}
          display='flex'
          alignItems={isXsSize ? 'flex-start' : 'center'}
          flexDirection='column'
          justifyContent='flex-start'
        >
          <Box css={styles.linkWrapper}>
            <Box>PROTOCOL</Box>
            <a href={CONFIG.whitepaperLink} target='_blank' rel='noreferrer'>
              Docs
            </a>
            <a href={CONFIG.auditLink} target='_blank' rel='noreferrer'>
              Audit
            </a>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          lg={2}
          display='flex'
          justifyItems='flex-start'
          alignItems={isXsSize ? 'flex-start' : 'center'}
          flexDirection='column'
          justifyContent='flex-start'
        >
          <Box css={styles.linkWrapper}>
            <Box>LEGAL</Box>
            <a
              href={CONFIG.termsOfServiceLink}
              target='_blank'
              rel='noreferrer'
            >
              Terms of Use
            </a>
            <a href={CONFIG.privacyPolicyLink} target='_blank' rel='noreferrer'>
              Privacy Policy
            </a>
          </Box>
        </Grid>
      </Grid>
      <Box css={styles.allRights}>All rights reserved © Huma {year}</Box>
    </Box>
  )
}
